const groupThousands = (value: string): string => value.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0')

const toMinorUnits = (value: string): bigint => {
  const negative = value.startsWith('-')
  const unsigned = negative ? value.slice(1) : value
  const [whole = '0', fraction = ''] = unsigned.split('.')
  const paddedFraction = fraction.padEnd(3, '0')
  const roundedFraction =
    BigInt(paddedFraction.slice(0, 2)) + (paddedFraction.charAt(2) >= '5' ? 1n : 0n)
  const minorUnits = BigInt(whole || '0') * 100n + roundedFraction
  return negative ? -minorUnits : minorUnits
}

export const formatMoney = (value: string, currency = 'UAH'): string => {
  const minorUnits = toMinorUnits(value)
  const absolute = minorUnits < 0n ? -minorUnits : minorUnits
  const whole = absolute / 100n
  const fraction = String(absolute % 100n).padStart(2, '0')
  const suffix = currency === 'UAH' ? '₴' : currency
  return `${minorUnits < 0n ? '−' : ''}${groupThousands(String(whole))},${fraction}\u00a0${suffix}`
}

export const moneySearchText = (value: string, currency = 'UAH'): string => {
  const formatted = formatMoney(value, currency)
  return [
    value,
    formatted,
    formatted.replaceAll('\u00a0', ' '),
    formatted.replaceAll('\u00a0', ''),
  ].join(' ')
}

const compactUnits = [
  { divisor: 100_000_000_000_000n, suffix: 'трлн' },
  { divisor: 100_000_000_000n, suffix: 'млрд' },
  { divisor: 100_000_000n, suffix: 'млн' },
] as const

export const formatMetricMoney = (value: string): string => {
  const minorUnits = toMinorUnits(value)
  const absolute = minorUnits < 0n ? -minorUnits : minorUnits
  const unit = compactUnits.find((candidate) => absolute >= candidate.divisor)
  if (!unit) return formatMoney(value)

  const scaledHundredths = (absolute * 100n + unit.divisor / 2n) / unit.divisor
  const whole = scaledHundredths / 100n
  const fraction = String(scaledHundredths % 100n)
    .padStart(2, '0')
    .replace(/0+$/, '')
  return `${minorUnits < 0n ? '−' : ''}${whole}${fraction ? `,${fraction}` : ''}\u00a0${unit.suffix}\u00a0₴`
}
